/**
 * La analítica (PostHog) solo corre en PRODUCCIÓN.
 *
 * staging y qa se construyen con la misma clave de PostHog y llenaban el
 * proyecto de sesiones y eventos de prueba mezclados con los de clientes. El
 * ambiente se reconoce por el backend al que apunta el build
 * (NEXT_PUBLIC_API_URL: ezdocu-backend-production / -staging / -qa), que
 * existe igual en el navegador y en el servidor. En el navegador, además, el
 * dominio tiene que ser el de producción.
 */

const DOMINIOS_PRODUCCION = new Set(['www.ezdocu.ai', 'ezdocu.ai']);

export function esBuildDeProduccion(apiUrl: string | undefined = process.env.NEXT_PUBLIC_API_URL): boolean {
  return !!apiUrl && /ezdocu-backend-production\./i.test(apiUrl);
}

/** Servidor (rutas /api de Next): solo el build de producción. */
export function analiticaActivaEnServidor(): boolean {
  return !!process.env.NEXT_PUBLIC_POSTHOG_KEY && esBuildDeProduccion();
}

/** Navegador: build de producción Y dominio de producción. */
export function analiticaActivaEnNavegador(hostname?: string): boolean {
  const host = hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '');
  return !!process.env.NEXT_PUBLIC_POSTHOG_KEY && esBuildDeProduccion() && DOMINIOS_PRODUCCION.has(host.toLowerCase());
}
